module.exports = __webpack_public_path__ + "static/img/bank-accounts-icon.a59b9ef4.svg";